<template>
  <v-container>
    <div class="d-flex align-baseline ga-4">
      <h1>Class Signup</h1>
      <span>
        <!--TODO Make this include the authed user too for ap classes-->
      </span>
    </div>
    <div class="d-flex align-baseline">
      <v-container min-height="80vh">
        <ClassCalendar height="100%" :manager="manager"></ClassCalendar>
      </v-container>
    </div>
  </v-container>
</template>

<script lang="ts" setup>
import { useRoute } from "vue-router";
import { useUser } from "@/composables/useUser";
import { ClassInstanceDTO, ClassSignupResponseDTO } from "@/autogen";
import { PersonNameInfoClass } from "@/api/dto/PersonNameInfo";
import { useClassManager } from "@/composables/classes/useClassManager";
import {
  memberOrderSessionKey,
  type MemberOrderSession,
} from "@/composables/shop/useMemberOrder";
const route = useRoute();
const { currentPersonRef: person, currentChildrenRef: children } = useUser();
const selectOptions = computed(() => {
  return [
    ...(children.value.map((a) => {
      return {
        title: new PersonNameInfoClass(a).getFullName(),
        value: a.personId,
      };
    }) || []),
    ...(person.value ? [{ title: "Me", value: person.value.personId }] : []),
  ];
});
function idFromParam() {
  if (typeof route.params.id == "string") {
    const id = parseInt(route.params.id);
    if (isNaN(id)) return undefined;
    return id;
  }
  return undefined;
}

const memberOrder = inject<MemberOrderSession | null>(
  memberOrderSessionKey,
  null,
);

const manager = useClassManager({
  selectablePeople: selectOptions,
  selectedPerson: idFromParam() ?? person.value?.personId,
  memberOrder: memberOrder ?? undefined,
});

watch(
  () => memberOrder?.order.value?.version,
  () => {
    manager.fetchClassEnrollmentAndEligibility(true);
  },
);
</script>
